import { DismissableMachineAlarm, machineAlarms } from '@uv/machine'
import i18n from '@/lib/i18n/config'

export type AlarmDisplayKey = DismissableMachineAlarm | `UNKNOWN_${number}`

export const alarmKeyFromIndex = (index: number): AlarmDisplayKey => {
  return machineAlarms[index] ?? `UNKNOWN_${index}`
}

const getUnknownAlarmIndex = (alarm: AlarmDisplayKey): number | null => {
  if (!alarm.startsWith('UNKNOWN_')) return null
  const parsedIndex = Number(alarm.replace('UNKNOWN_', ''))
  return Number.isInteger(parsedIndex) && parsedIndex >= 0 ? parsedIndex : null
}

export const formatAlarmName = (alarm: AlarmDisplayKey) => {
  const unknownAlarmIndex = getUnknownAlarmIndex(alarm)
  if (unknownAlarmIndex !== null) return `Unknown alarm ${unknownAlarmIndex}`

  switch (alarm) {
    case 'UV_HOT': {
      return i18n.t('installation.alert-alarms.uv-hot')
    }
    case 'AIR_HOT': {
      return i18n.t('installation.alert-alarms.air-hot')
    }
    case 'MOTOR': {
      return i18n.t('installation.alert-alarms.motor')
    }
    case 'AIRSUPPLY': {
      return i18n.t('translation:installation.alert-alarms.airsupply')
    }
    case 'HEAD': {
      return i18n.t('translation:installation.alert-alarms.head')
    }
    case 'PRESSURE': {
      return i18n.t('translation:installation.alert-alarms.pressure')
    }
    case 'SLIP': {
      return i18n.t('translation:installation.alert-alarms.slip')
    }
    case 'SENSOR': {
      return i18n.t('translation:installation.alert-alarms.sensor')
    }
    case 'UV_POWER': {
      return i18n.t('translation:installation.alert-alarms.uv-power')
    }
    case 'WIFI': {
      return i18n.t('translation:installation.alert-alarms.wifi')
    }
  }

  return 'Unknown alarm'
}

export const formatAlarmTranslationBaseKey = (alarm: AlarmDisplayKey): string | null => {
  if (getUnknownAlarmIndex(alarm) !== null) return null

  switch (alarm) {
    case 'UV_HOT': {
      return 'uv-hot'
    }
    case 'AIR_HOT': {
      return 'air-hot'
    }
    case 'MOTOR': {
      return 'motor'
    }
    case 'AIRSUPPLY': {
      return 'airsupply'
    }
    case 'HEAD': {
      return 'head'
    }
    case 'PRESSURE': {
      return 'pressure'
    }
    case 'SLIP': {
      return 'slip'
    }
    case 'SENSOR': {
      return 'sensor'
    }
    case 'UV_POWER': {
      return 'uv-power'
    }
    case 'WIFI': {
      return 'wifi'
    }
  }

  return null
}
